import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';

import { selectAllStations } from '../../store/stationsSlice'
import { StationFilterContext } from '../../contexts/StationFilterContext';


export const StationCodeSelector = () => {
  
  const stations = useSelector(selectAllStations)
  const {state, dispatch} = useContext(StationFilterContext);

  const [allOfStationsAreSelected, setAllOfStationsAreSelected] = useState()
  const [allOfStationsAreDeselected, setAllOfStationsAreDeselected] = useState()

  const { t } = useTranslation();

  useEffect(() => {
    if (stations.length > 0) {
      const allOfStationsAreSelected = {}
      const allOfStationsAreDeselected = {}
      stations.forEach(({code}) => {
        allOfStationsAreSelected[code] = true
        allOfStationsAreDeselected[code] = false
      })
      setAllOfStationsAreSelected(allOfStationsAreSelected)
      setAllOfStationsAreDeselected(allOfStationsAreDeselected)
    }    
  }, [stations])

  const selectAll = () => {
    dispatch({
      type: 'SET_STATION_CODE_SELECTOR',
      value: allOfStationsAreSelected
    })
  }

  const deselectAll = () => {
    dispatch({
      type: 'SET_STATION_CODE_SELECTOR',
      value: allOfStationsAreDeselected
    })
  }

  const toggleStationSelectedState = (event) => {
    if (event.target && event.target.title) {
      const stationCode = event.target.title
      dispatch({
        type: 'SET_STATION_SELECT_STATE',
        stationCode: stationCode,
        value: !state.stationCodeSelector[stationCode]
      })
    }    
  }

  return (
    <>
      <button type="button" className="waves-effect waves-light button-mini v-align-base"onClick={selectAll}>
        {t('form.selectAll')}
      </button>
      &nbsp;
      <button type="button" className="waves-effect waves-light button-mini v-align-base" onClick={deselectAll}>
        {t('form.selectNone')}
      </button>
      <div className="clearfix"></div>
      <div style={{width:"100%"}}>
        <div className="obser-info" id="demo-stay" >
          <div className="vsb-menu" 
            style={{zIndex: 1999, visibility: 'visible', boxShadow: 'none', minHeight: '310px', position: 'relative', left: '0px', top: '0px'}}
          >
            <ul className="multi row" style={{maxHeight: '300px', minWidth: '140px', maxWidth: '280px', minHeight: '25px'}}
              onClick={toggleStationSelectedState}
            >
              {stations.map(station => (
                <li
                  className={state.stationCodeSelector[station.code] ? "col l3 m6 s12 active" : "col l3 m6 s12"}
                  key={station.code}
                  title={station.code}
                >
                  {station.code} ({station.name})
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

